import { useEffect, useState } from "react";
import {
  getPrivacyConsentState,
  setAnalyticsConsent,
  subscribePrivacyConsent,
} from "@/services/privacy/privacyConsentService";

export function usePrivacyConsent() {
  const [state, setState] = useState(() => getPrivacyConsentState());

  useEffect(() => {
    return subscribePrivacyConsent((next) => {
      setState(next);
    });
  }, []);

  return {
    consent: state,
    hasAnswered: state != null,
    analyticsEnabled: state?.analytics === true,
    acceptAnalytics: () => setAnalyticsConsent(true),
    rejectAnalytics: () => setAnalyticsConsent(false),
    setAnalyticsEnabled: (enabled) => setAnalyticsConsent(Boolean(enabled)),
  };
}
